<template>
  <section class="section">
    <div class="container mt-6-desktop">
      <div class="columns">
        <div class="column has-text-centered">
          <img :src="networkServer" alt />
          <h2 class="title">Extractores disponibles</h2>
          <p class="subtitle">
            Trabajamos tanto generando extractores utilizando las API de tus
            aplicaciones como también creando RPAs para servicios que no cuenten
            con una. Si no tenemos lo que buscas, escríbenos.
          </p>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="columns is-centered">
        <div class="column is-narrow">
          <ExtractorFilter :tags="tagList" />
        </div>
      </div>
    </div>

    <div class="container py-5" :class="$style.showSeparator">
      <div class="columns is-multiline">
        <div
          v-for="extractor in data"
          :key="extractor.id"
          class="column is-6-mobile is-3-tablet is-inline-flex-mobile"
        >
          <router-link :to="{ path: `/integrations/${extractor.slug}` }">
            <div class="tile is-ancestor connector">
              <div class="tile is-parent has-text-centered">
                <article
                  class="is-child notification is-primary is-light"
                  :class="[$style.tilePadding, $style.tileStyles]"
                >
                  <img
                    :class="$style.tileImage"
                    :src="extractor.logo"
                    :alt="extractor.slug"
                  />
                  <p class="subtitle">
                    <span class="tag is-rounded">{{ extractor.type }} </span>
                  </p>
                </article>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { networkServer } from "@/assets/images";
import ExtractorFilter from "@/components/ExtractorFilter";

export default {
  name: "Partner",
  components: {
    ExtractorFilter,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      networkServer: networkServer,
    };
  },
  computed: {
    ...mapGetters("root", {
      tagList: "getListTags",
    }),
  },
};
</script>

<style lang="scss" module>
@import "../styles/home.scss";

.showSeparator {
  border-bottom: 1px solid #d0d0d0;
}
</style>
